export default __webpack_public_path__ + "a8641eb3d06919bb9c1cc329bd2a9832.svg";